module.exports = __webpack_public_path__ + "static/img/分类图片1@2x.f124e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/分类图片1@2x.png
// module id = 5mkQ
// module chunks = 192